<!--&================= TITLE =================&-->
<div class="title-components">
  <h1>Versión Por Revisión</h1>
</div>

<!--&================= CONTAINER TABLE =================&-->
<div class="container-global-components ConLA">
  <div class="Table-container-Global Local-LA">
    <table>
      <thead>
        <th *ngFor="let Header of HeadersLA" class="{{Header.Key_Header}}">{{Header.Name}}</th>
      </thead>
      <tbody>
        <tr>
          <td>{{LastApprovedCCP.Revision_No}}</td>
          <td>{{LastApprovedCCP.Name}}</td>
          <td>{{LastApprovedCCP.Model_Year===0?'N/A':LastApprovedCCP.Model_Year}}</td>
          <td>{{LastApprovedCCP.Code}}</td>
          <td>{{LastApprovedCCP.Invoice_4M}}</td>
          <td>{{DateFormat(LastApprovedCCP.Date_Created)}}</td>
          <td>{{DateFormat(LastApprovedCCP.Date_End)}}</td>
          <td>{{LastApprovedCCP.Approver_Name}}</td>
          <td>{{LastApprovedCCP.Reviewer_Name}}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <button (click)="DownloadFile()" class="Btn-Download-Local-LA Btn-Download-Global" id="Btn-Download">
    <div class="Content-Download">
      <span class="Progress-Bar-Task" id="Progress-Bar-Task"></span>
      <span class="Btn-Text" id="Text-Btn">Descargar</span>
      <i class="fa-solid fa-cloud-arrow-down" id="Icon-Btn"></i>
    </div>
  </button>
</div>


<!--&================= LOADER =================&-->
<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>
